/**
 * Shared pdf.js worker configuration (side-effect module).
 *
 * Every consumer of pdfjs-dist (pdf-converter.ts, the Workspace PdfViewer)
 * imports this module instead of setting GlobalWorkerOptions itself, so the
 * worker is bundled by Vite from the same pdfjs-dist install as the API —
 * versions can never drift, and there is no CDN dependency at runtime.
 */
import { GlobalWorkerOptions } from "pdfjs-dist";
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

GlobalWorkerOptions.workerSrc = workerUrl;
